import React from 'react';

// ============================================================
// SettingsPage — Session 1 (Phase 2 shell) placeholder.
// Full implementation lands in a later session; this file exists so
// AdminShell's page router has something to render for its slug and
// the shell can be verified end-to-end before any real data is wired.
//
// Firestore cost when this placeholder mounts: ZERO reads/writes.
// ============================================================

export default function SettingsPage() {
  return (
    <div className="sa-page-placeholder">
      <div className="sa-page-placeholder-icon">🛠️</div>
      <div className="sa-page-placeholder-title">Coming in a future session</div>
      <div className="sa-page-placeholder-text">
        System configuration will land here — commission defaults, notification templates, and feature flags.
      </div>
    </div>
  );
}
